import HeroNav from './components/HeroNav';
import DotHeroTitle from './components/DotHeroTitle';
import ParticleImage from './components/ParticleImage';

export default function Home() {
  return (
    <div className="h-screen min-h-[760px] bg-white text-neutral-900 font-mono flex flex-col overflow-hidden">
      <HeroNav />

      <main className="flex-1 px-6 md:px-10 pt-5 md:pt-6 pb-6 md:pb-8 min-h-0">
        <div className="grid grid-cols-12 gap-5 h-full">
          {/* =================== LEFT BIG TILE — SONORI =================== */}
          <div className="col-span-12 lg:col-span-5 flex flex-col gap-3 min-h-0">
            <div className="relative w-full flex-1 overflow-hidden cursor-crosshair group min-h-0 bg-neutral-100">
              <ParticleImage
                src="https://readdy.ai/api/search-image?query=Full%20body%20editorial%20fashion%20portrait%20of%20a%20young%20brunette%20woman%20with%20slick%20back%20hair%20walking%20across%20a%20black%20and%20white%20striped%20crosswalk%2C%20wearing%20a%20brown%20pinstripe%20vest%20and%20a%20long%20black%20satin%20skirt%2C%20carrying%20a%20small%20woven%20straw%20basket%20bag%20and%20a%20draped%20pinstripe%20blazer%2C%20vintage%20sunglasses%20hanging%20from%20cord%20necklace%2C%20clean%20white%20wood%20paneled%20wall%20background%2C%20natural%20warm%20daylight%2C%20cinematic%20street%20style%20photography%2C%20muted%20earthy%20tones%2C%20minimalist%20composition%2C%20high%20fashion%20magazine%20editorial&width=900&height=1200&seq=hero-sonori-street-02&orientation=portrait"
                alt="SONORI"
                step={5}
                revealRadius={170}
                restScatter={6}
                introDuration={1600}
                introStagger={700}
              />

              {/* Frosted overlay card */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="relative w-[68%] aspect-square max-w-[340px] backdrop-blur-md bg-white/10 border border-white/20 flex items-center justify-center text-white">
                  <h2 className="text-3xl md:text-4xl font-semibold tracking-[0.08em]">SONORI</h2>
                </div>
              </div>
            </div>
          </div>

          {/* =================== RIGHT MULTI-TILE AREA =================== */}
          <div className="col-span-12 lg:col-span-7 flex flex-col gap-4 min-h-0">
            {/* ---- Top row ---- */}
            <div className="grid grid-cols-7 gap-5 flex-1 min-h-0">
              {/* NOVA FOUNDRY tile */}
              <div className="col-span-7 sm:col-span-2 flex flex-col gap-2 min-h-0">
                <div className="relative w-full flex-1 bg-[#f1f1f1] overflow-hidden cursor-crosshair group min-h-0">
                  <ParticleImage
                    src="https://readdy.ai/api/search-image?query=Single%20premium%20silver%20cinema%20camera%20lens%20floating%20centered%20on%20pure%20light%20gray%20studio%20background%2C%20mechanical%20detail%2C%20brushed%20aluminum%20finish%2C%20deep%20black%20glass%20element%2C%20soft%20directional%20studio%20light%2C%20editorial%20product%20photography%2C%20clean%20minimalist%20composition%2C%20professional%20commercial%20lighting%2C%20no%20text%2C%20no%20logo&width=600&height=600&seq=hero-lens-02&orientation=squarish"
                    alt="NOVA FOUNDRY"
                    step={4}
                    revealRadius={120}
                    restScatter={4}
                    introDuration={1500}
                    introStagger={650}
                  />
                </div>
                <div className="text-[10px] tracking-[0.14em] leading-tight">
                  <div className="font-semibold">NOVA FOUNDRY</div>
                  <div className="text-neutral-400 mt-0.5">TECHNOLOGY</div>
                </div>
              </div>

              {/* Yellow hero title panel — dot matrix */}
              <div className="col-span-7 sm:col-span-5">
                <div className="relative w-full h-full bg-[#f0ff00] overflow-hidden">
                  <h1 className="sr-only">STUDIO</h1>
                  <DotHeroTitle text="STUDIO" />
                  <span className="absolute right-4 bottom-3 text-black text-base font-semibold pointer-events-none">®</span>
                </div>
              </div>
            </div>

            {/* ---- Bottom row ---- */}
            <div className="grid grid-cols-7 gap-5 flex-1 min-h-0">
              {/* SUNDANCE black tilted card */}
              <div className="col-span-7 sm:col-span-2 flex flex-col gap-2 min-h-0">
                <div className="relative w-full flex-1 bg-white overflow-hidden cursor-pointer group flex items-center justify-center min-h-0">
                  <div className="relative w-[75%] h-[78%] bg-black -rotate-[14deg] overflow-hidden flex items-center justify-center transition-transform duration-500 group-hover:-rotate-[10deg]">
                    <div className="text-white text-center leading-[1.05] font-semibold tracking-tight px-2 select-none">
                      <div className="text-[13px] md:text-[15px]">SUNDANCE</div>
                      <div className="text-[13px] md:text-[15px]">BERLIN</div>
                      <div className="text-[13px] md:text-[15px]">CANNES</div>
                      <div className="text-[13px] md:text-[15px]">FESTIVAL</div>
                    </div>
                  </div>
                </div>
                <div className="text-[10px] tracking-[0.14em] leading-tight">
                  <div className="font-semibold">STUDIO VALE</div>
                  <div className="text-neutral-400 mt-0.5">MARKETING</div>
                </div>
              </div>

              {/* NEUMA APP */}
              <div className="col-span-7 sm:col-span-3 flex flex-col gap-2 min-h-0">
                <div className="relative w-full flex-1 overflow-hidden cursor-crosshair group min-h-0 bg-neutral-900">
                  <ParticleImage
                    src="https://readdy.ai/api/search-image?query=Athlete%20foot%20wearing%20a%20white%20performance%20running%20shoe%20kicking%20up%20glowing%20orange%20dust%20and%20fiery%20sparks%20against%20deep%20black%20background%2C%20dramatic%20cinematic%20motion%20blur%2C%20warm%20amber%20and%20red%20smoke%20particles%2C%20moody%20editorial%20sport%20photography%2C%20high%20contrast%2C%20fine%20dust%20texture%2C%20powerful%20action%20moment&width=900&height=600&seq=hero-shoe-fire-03&orientation=landscape"
                    alt="NEUMA"
                    step={5}
                    revealRadius={160}
                    restScatter={7}
                    introDuration={1700}
                    introStagger={750}
                  />
                </div>
                <div className="text-[10px] tracking-[0.14em] leading-tight">
                  <div className="font-semibold">NEUMA APP</div>
                  <div className="text-neutral-400 mt-0.5">MARKETING</div>
                </div>
              </div>

              {/* CARABINER */}
              <div className="col-span-7 sm:col-span-2 flex flex-col gap-2 min-h-0">
                <div className="relative w-full flex-1 bg-[#e9e9e9] overflow-hidden cursor-crosshair group min-h-0">
                  <ParticleImage
                    src="https://readdy.ai/api/search-image?query=Single%20matte%20black%20climbing%20carabiner%20floating%20centered%20on%20plain%20warm%20light%20gray%20studio%20background%2C%20premium%20outdoor%20gear%20product%20photography%2C%20subtle%20engraved%20brand%20mark%2C%20clean%20minimalist%20composition%2C%20soft%20directional%20studio%20lighting%2C%20editorial%20catalogue%20style%2C%20ultra%20detailed%20aluminum%20texture%2C%20no%20text%2C%20no%20logo&width=600&height=750&seq=hero-carabiner-04&orientation=portrait"
                    alt="Outdoor"
                    step={4}
                    revealRadius={120}
                    restScatter={4}
                    introDuration={1600}
                    introStagger={650}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}